var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInAsteptare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 32"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0625,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFF4E4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "browse_gallery"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_302_2847",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 17
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 4,
    y: 4.0625,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_302_2847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "browse_gallery_2",
    d: "M12.6667 11.7958V9.39583C12.6667 9.20694 12.6028 9.04861 12.475 8.92083C12.3472 8.79306 12.1889 8.72917 12 8.72917C11.8111 8.72917 11.6528 8.79306 11.525 8.92083C11.3972 9.04861 11.3333 9.20694 11.3333 9.39583V12.0458C11.3333 12.1347 11.35 12.2208 11.3833 12.3042C11.4167 12.3875 11.4667 12.4625 11.5333 12.5292L13.4 14.3958C13.5222 14.5181 13.6778 14.5792 13.8667 14.5792C14.0556 14.5792 14.2111 14.5181 14.3333 14.3958C14.4556 14.2736 14.5167 14.1181 14.5167 13.9292C14.5167 13.7403 14.4556 13.5847 14.3333 13.4625L12.6667 11.7958ZM12 18.0625C11.1667 18.0625 10.3861 17.9042 9.65833 17.5875C8.93056 17.2708 8.29722 16.8431 7.75833 16.3042C7.21944 15.7653 6.79167 15.1319 6.475 14.4042C6.15833 13.6764 6 12.8958 6 12.0625C6 11.2292 6.15833 10.4486 6.475 9.72083C6.79167 8.99306 7.21944 8.35972 7.75833 7.82083C8.29722 7.28194 8.93056 6.85417 9.65833 6.5375C10.3861 6.22083 11.1667 6.0625 12 6.0625C12.8333 6.0625 13.6139 6.22083 14.3417 6.5375C15.0694 6.85417 15.7028 7.28194 16.2417 7.82083C16.7806 8.35972 17.2083 8.99306 17.525 9.72083C17.8417 10.4486 18 11.2292 18 12.0625C18 12.8958 17.8417 13.6764 17.525 14.4042C17.2083 15.1319 16.7806 15.7653 16.2417 16.3042C15.7028 16.8431 15.0694 17.2708 14.3417 17.5875C13.6139 17.9042 12.8333 18.0625 12 18.0625ZM12 16.7292C13.3 16.7292 14.4028 16.2764 15.3083 15.3708C16.2139 14.4653 16.6667 13.3625 16.6667 12.0625C16.6667 10.7625 16.2139 9.65972 15.3083 8.75417C14.4028 7.84861 13.3 7.39583 12 7.39583C10.7 7.39583 9.59722 7.84861 8.69167 8.75417C7.78611 9.65972 7.33333 10.7625 7.33333 12.0625C7.33333 13.3625 7.78611 14.4653 8.69167 15.3708C9.59722 16.2764 10.7 16.7292 12 16.7292Z",
    fill: "#FF9700"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInAsteptare);
export default __webpack_public_path__ + "static/media/in_asteptare.4bb9d261ac26aeb8187cbc3cf9f8b103.svg";
export { ForwardRef as ReactComponent };